import { Link } from "react-router-dom";
// ======= IMPORT SOLID FONT AWESOME ======== //
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupeeSign, faStar } from "@fortawesome/free-solid-svg-icons";
import ProfileBadge from "../comman/ProfileBadge";

// ===== Import Iconify for icons ===== //
import { Icon } from "@iconify/react";
import { useProfile } from "../../hook/useProfile";

const FeedHeader = ({
  post,
  currentUserId,
  isPublic,
  hideFollowButton,
  onFollowToggle,
  followLoading,
  onEdit,
  onSave,
  onDelete,
  // onReport = { onReport },
  onReport = () => {},
  hideActionButton,
  hideEditButton,
  isReposted,
}) => {
  // ✅ FOLLOW THE SAME PATTERN AS POSTFOOTER
  // Handle repost / normal post structure
  const actualPost = post?.post || post;
  const postId = actualPost?._id;
  const isSaved = actualPost?.isSaved;

  const user = actualPost?.user || {};
  const isPrimeUser = user?.role === "PRIME";

  const isOwner = currentUserId === user?._id;
  // console.log(hideActionButton, "header post")

  const profileLink = isOwner
    ? `/my/${post?.user?._id}/profile`
    : `/user/${post?.user?._id}/profile`;

  const profilePic = user?.profilePic;
  const userName = user?.fullName;
  const adhaarVerified = user?.adhaarVerified;
  const createdAt = post?.createdAt;
  // const createdAt = post?.post?.createdAt || post?.createdAt; // ✅ check nested first
  const isBatchPost = user?.isBatch;
  const feedType = actualPost?.feedType || "PUBLIC";

  const { isProfileInfo } = useProfile();

  const isLoggedInPrimeUser = isProfileInfo?.role === "PRIME";

  const isPrime =
    user?.role === "PRIME" || // target profile is PRIME
    isProfileInfo?.role === "PRIME"; // logged-in user is PRIME
  const isVerified = adhaarVerified === "VERIFIED";

  // ✅ Date formatter
  const getDateFromId = (id) => {
    if (!id) return "";
    const timestamp = parseInt(id.substring(0, 8), 16) * 1000;
    const date = new Date(timestamp);
    return (
      date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      }) +
      ", " +
      date
        .toLocaleTimeString("en-GB", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        })
        .replace("AM", "am")
        .replace("PM", "pm")
    );
  };

  // const isPrime = actualPost?.feedType === "PRIME";
  return (
    <div className="post-header-container d-flex justify-content-between align-items-center">
      {/* ===== LEFT SECTION ===== */}
      <div className="post-header">
        <div className="post-header-link text-decoration-none text-dark">
          <div className="feed-user-profile-img-box">
            {/* <img className="feed-user-profile-img"
              src={
                post?.user?.profilePic
                  ? `${post?.user?.profilePic}`
                  : "https://cdn-icons-png.flaticon.com/512/149/149071.png"
              }
              alt="user"
              onError={(e) => {
                e.target.src = "https://cdn-icons-png.flaticon.com/512/149/149071.png";
              }}
            /> */}
            <ProfileBadge
              isBatch={isBatchPost}
              ProfileLink={profileLink}
              profilePic={profilePic}
            />
          </div>
        </div>

        <div>
          <p className="username">
            {/* <Link
              to={profileLink}
              className="post-header-link text-decoration-none text-dark"
            >
              {userName || "Unknown User"}

              {feedType === "PUBLIC" &&
                (adhaarVerified === "VERIFIED" ? (
                  <span className="feed-verified-badge ms-1">
                    <Icon icon="ic:baseline-verified" />
                  </span>
                ) : (
                  isOwner && (
                    <span className="feed-verified-badge ms-1">
                      <Icon
                        icon="ic:sharp-warning-amber"
                        className="text-warning"
                      />
                    </span>
                  )
                ))}

              {feedType === "PRIME" &&
                (adhaarVerified === "VERIFIED" ? (
                  <span className="feed-verified-badge-success ms-1">
                    <Icon icon="ic:baseline-verified" />
                  </span>
                ) : (
                  isOwner && (
                    <span className="feed-verified-badge ms-1">
                      <Icon
                        icon="ic:sharp-warning-amber"
                        className="text-warning"
                      />
                    </span>
                  )
                ))}
            </Link> */}

            <Link
              to={profileLink}
              className="post-header-link text-decoration-none text-dark"
            >
              {userName || "Unknown User"}

              {/* ✅ VERIFIED BADGE FIX */}
              {isVerified && (
                <span
                  className={`ms-1 ${
                    isPrimeUser
                      ? "feed-verified-badge-success" // 🟢 GREEN (PRIME)
                      : "feed-verified-badge" // 🔵 BLUE (PUBLIC)
                  }`}
                >
                  <Icon icon="ic:baseline-verified" />
                </span>
              )}
            </Link>

            {post?.isMonetized && (
              <FontAwesomeIcon
                icon={faIndianRupeeSign}
                className="ms-2 theme-color"
              />
            )}
          </p>

          <p
            className="group-name"
            style={{ fontSize: "12px", color: "#888", margin: "0" }}
          >
            {getDateFromId(post?._id)}
          </p>
        </div>
      </div>

      <div className="dropdown post-ellipsis me-2 d-flex align-items-center gap-2">
        {/* FOLLOW BUTTON - commented out as per original */}

        {/* MENU */}
        {!hideActionButton && (
          <span
            className="btn p-0 border-0 bg-transparent"
            data-bs-toggle="dropdown"
          >
            ⋮
          </span>
        )}

        {/* DROPDOWN - FIXED USING actualPost */}
        <ul
          className={`dropdown-menu dropdown-menu-end ${hideActionButton ? "shadow-none" : ""}`}
        >
          {isOwner ? (
            <>
              {!hideEditButton && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => onEdit(post)} // Keep post for edit as it needs full post
                  >
                    Edit Post
                  </button>
                </li>
              )}

              {/* SAVE/UNSAVE POST - USING actualPost */}
              <li>
                <button
                  className="dropdown-item"
                  onClick={() => {
                    if (typeof onSave === "function") {
                      onSave(postId); // Use postId (actualPost._id)
                    } else {
                      console.error("onSave is not a function");
                    }
                  }}
                >
                  {isSaved ? "Unsave Post" : "Save Post"}
                </button>
              </li>

              <li>
                <button
                  className="dropdown-item text-danger"
                  onClick={() => onDelete(post?._id)}
                >
                  Delete Post
                </button>
              </li>
            </>
          ) : (
            !hideActionButton && (
              <>
                {/* SAVE/UNSAVE POST FOR NON-OWNERS - USING actualPost */}
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      if (typeof onSave === "function") {
                        onSave(postId); // Use postId (actualPost._id)
                      } else {
                        console.error("onSave is not a function");
                      }
                    }}
                  >
                    {isSaved ? "Unsave Post" : "Save Post"}
                  </button>
                </li>

                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => onReport({ id: post?._id, type: "post" })}
                  >
                    Report Post
                  </button>
                </li>
              </>
            )
          )}
        </ul>
      </div>
    </div>
  );
};

export default FeedHeader;
